import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleOfferClassif.errors.";

const defaultClassifExternalSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketAutomationReceivedRuleOfferClassifClassificationsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const offerClassificationSchema = z
  .object({
    id: z.string().optional(),
    requireTurnSlotClassif: z.boolean(),
    updateSlotClassif: z.boolean(),
    defaultClassifExternal: defaultClassifExternalSchema.nullish(),
    classifications: z
      .array(ticketAutomationReceivedRuleOfferClassifClassificationsSchema)
      .nullish(),
  })
  .superRefine((val, ctx) => {
    if (
      val.requireTurnSlotClassif &&
      (!val.classifications || val.classifications?.length === 0)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["classifications"],
        message: translationPath + "classifications",
      });
    }
    if (val.updateSlotClassif && !val.defaultClassifExternal) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["defaultClassifExternal"],
        message: translationPath + "default_classification",
      });
    }
  });

export type TOfferClassificationForm = z.infer<
  typeof offerClassificationSchema
>;
